module.exports = __webpack_public_path__ + "img/part_tab3_box2_3.95a2d677.jpg";